import { render, staticRenderFns } from "./BackForwardBtn.vue?vue&type=template&id=da2ece82&scoped=true&"
import script from "./BackForwardBtn.vue?vue&type=script&lang=js&"
export * from "./BackForwardBtn.vue?vue&type=script&lang=js&"
import style0 from "./BackForwardBtn.vue?vue&type=style&index=0&id=da2ece82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2ece82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
